import React, { useState } from "react";
import { format, parseISO } from "date-fns";
import { CalendarDays } from "lucide-react";
import { Calendar } from "../ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";

export const londonToday = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/London" }).format(new Date());

const AdminDateField = ({ value, onChange, min, testid }) => {
  const [open, setOpen] = useState(false);
  const minDate = min ? parseISO(min) : null;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className="flex h-11 w-full items-center gap-2 rounded-lg border border-white/10 bg-[#0b0c0f] px-3 text-left text-sm text-white" data-testid={testid}>
          <CalendarDays className="h-4 w-4 text-brand" />{value ? format(parseISO(value), "EEE d MMM yyyy") : "Pick a date"}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto border-white/10 bg-[#111217] p-0 text-white" align="start">
        <Calendar mode="single" selected={value ? parseISO(value) : undefined} defaultMonth={value ? parseISO(value) : undefined} weekStartsOn={1}
          disabled={(d) => !!minDate && d < minDate}
          onSelect={(d) => { if (d) { onChange(format(d, "yyyy-MM-dd")); setOpen(false); } }}
          classNames={{ day_selected: "bg-brand text-white hover:bg-brand focus:bg-brand", day_today: "border border-brand/50" }}
          initialFocus data-testid={`${testid}-calendar`} />
      </PopoverContent>
    </Popover>
  );
};

export default AdminDateField;
